import { Link } from "react-router-dom";

import H2 from "../components/H2";
import ExecutiveEducationApplyForm from "../components/forms/ExecutiveEducationApplyForm";

export default function ExecutiveEducationApply() {
  return (
    <div className="mb-20 lg:mb-32">
      <nav className="flex mt-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-3">
          <li>
            <div className="flex items-center">
              <Link to="/events" className="text-sm font-medium text-gray-700">Events</Link>
            </div>
          </li>
          <li aria-current="page">
            <div className="flex items-center">
              <svg aria-hidden="true" className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
              <span className="ml-1 md:ml-2 text-sm font-medium text-bahyellow"><Link to="/events/a4b13e79/banking-finance-in-the-age-of-ai" className="text-sm font-medium text-gray-700">Banking & Finance in the Age of AI</Link></span>
            </div>
          </li>
          <li aria-current="page">
            <div className="flex items-center">
              <svg aria-hidden="true" className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
              <span className="ml-1 md:ml-2 text-sm font-medium text-bahyellow">Apply</span>
            </div>
          </li>
        </ol>
      </nav>
      <H2 title="Banking & Finance in the Age of AI">
        <p className="mt-4">
          Please complete the form below to apply for the Banking & Finance in the Age of AI Executive Programme,
          organised by the Brussels-Africa Hub in partnership with Tsinghua University School of Economics
          and Management (Tsinghua SEM).
        </p>
      </H2>
      <ExecutiveEducationApplyForm />
    </div>
  );
}
